import React from 'react';
import { Icon, Modal } from 'antd';

export const showError = (err) => {
  let errorTitle = 'Something went wrong';
  let errorDesc =
    'We were unable to fulfill your request. Please try again later.';

  if (err.response && err.response.data && err.response.data.errorMessage) {
    errorDesc = err.response.data.errorMessage;
  } else if (err && err.data && err.data.errorMessage) {
    errorDesc = err.data.errorMessage;
  }

  if (err.response && err.response.data && err.response.data.errorTitle) {
    errorTitle = err.response.data.errorTitle;
  } else if (err && err.data && err.data.errorTitle) {
    errorTitle = err.data.errorTitle;
  }

  console.log({ err, errorTitle, errorDesc });

  // store.dispatch({
  //   type: 'SHOW_ERROR',
  //   payload: {
  //     errorTitle: errorTitle,
  //     errorDesc: errorDesc,
  //   },
  // });
  Modal.error({
    title: errorTitle,
    content: errorDesc,
    icon: (
      <Icon type="exclamation-circle" theme="twoTone" twoToneColor="#ff856a" />
    ),
    keyboard: true,
    onOk: () => Promise.resolve(true),
  });
};

const formatTime = (time) => {
  const [hour, minute, second] = time.split(':');
  const hours = parseInt(hour, 10);
  const minutes = parseInt(minute, 10);

  // Check if it's AM or PM
  const ampm = hours >= 12 ? 'pm' : 'am';

  // Convert hours to 12-hour format
  const formattedHour = hours % 12 === 0 ? 12 : hours % 12;

  // Add leading zeros to minutes if needed
  const formattedMinute = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHour}:${formattedMinute} ${ampm}`;
};

const getDayName = (dow) => {
  const dayNames = ['', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return dayNames[dow];
};

const DynamicTable = ({ warningData }) => {
  // Function to render table rows dynamically based on data
  const renderTableRows = () => {
    return warningData.map((item, rowIndex) => (
      <tr key={rowIndex}>
        <td>{formatTime(item.startTime)}</td>
        <td>{formatTime(item.endTime)}</td>
        <td>{getDayName(item.dow)}</td>
      </tr>
    ));
  };

  return (
    <div>
      <h3>Overlapping slots Details</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', borderSpacing: '10px' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>startTime</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>endTime</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>day</th>
          </tr>
        </thead>
        <tbody>{renderTableRows()}</tbody>
      </table>
    </div>
  );
};


export const showSlotOverlappingWarning = (warningData) => {
  console.log('inside showSlotOverlappingWarning');
  let errorTitle = 'Attention !!';
  let errorDesc = <div>
    <h3>The below slots were found overlapping and hence not added</h3>
    <div>{DynamicTable({ warningData })}</div>

  </div>;
  console.log(`error desc ${errorDesc}`);
  // store.dispatch({
  //   type: 'SHOW_ERROR',
  //   payload: {
  //     errorTitle: errorTitle,
  //     errorDesc: errorDesc,
  //   },
  // });
  Modal.error({
    title: errorTitle,
    content: errorDesc,
    icon: (
      <Icon type="exclamation-circle" theme="twoTone" twoToneColor="#ff856a" />
    ),
    keyboard: true,
    onOk: () => Promise.resolve(true),
  });
};

export const showValidationError = (err) => {
  Modal.error({
    title: err.errorTitle,
    content: err.errorDesc,
    icon: (
      <Icon type="exclamation-circle" theme="twoTone" twoToneColor="#ff856a" />
    ),
    keyboard: true,
    onOk: () => Promise.resolve(true),
  });
};
